import React, { useState, useEffect, useRef } from "react";
import { addCommas, removeNonNumeric } from "../Shared/Utility";

type Props = {
  Prefix: string;
  Suffix: string;
  ToFixed: number;
  ColumnName: string;
  PID: any;
  Value: any;
  ClassName:string;
  Disabled:boolean;
};

function InputMaskReadOnly(props: Props) {
 
  return (
    <>
     {(props.Value !=undefined && !isNaN(props.Value)) ? (<span>{props.Prefix+ props.Value?.toLocaleString(undefined, {
          minimumFractionDigits: props.ToFixed,
          maximumFractionDigits: props.ToFixed,
        }) + props.Suffix}</span>):(<span>{props.Prefix}0{props.Suffix}</span>) }
    </>
  );
}

export default InputMaskReadOnly;
